// eBL term templates (cross-backend → admin-corev2). GET /termTemplate.
import { adminRequest } from './client.js';

const api = {
	getModelTerms: () => adminRequest('GET', '/termTemplate'),
	index: () => adminRequest('GET', '/termTemplate'),
};

export default api;
